

<section *ngIf="home" class="home-wrapper transition-2 page-padding"  [ngClass]="{'grid-transform':activeGrid}">
    <section id="main-grid " class="page-container transition-grid position-relative"
    [ngClass]="{'prevent-animation':stopScrollAnimation}"
    #gridcontainer
    [ngStyle]="{'transform': 'translateY(' + counter + 'px)', '-webkit-transform': 'translateY(' + counter + 'px)', '-moz-transform': 'translateY(' + counter + 'px)','-o-transform': 'translateY(' + counter + 'px)'}" 
    mouseWheel
    (mouseWheelDown)="mouseWheelDownFunc($event)"
    (mouseWheelUp)="mouseWheelUpFunc($event)"
    >
        <div class="w-100 H-100 H-100-full overflow-hidden position-relative  remove-grid-borders-top">
            <app-home-video [content]="home.video_section"></app-home-video>
        </div>
        <div class="w-100 H-100 H-100-full overflow-hidden grid-item-space disable-grid-space">
            <app-home-reel [content]="home.get_to_know_us_and_reel_section"></app-home-reel>
        </div>
        <div class="w-100 H-100 H-100-full H-auto-mobile position-relative overflow-hidden disable-grid-space">
            <app-home-categories></app-home-categories>
        </div>
        <div class="w-100 H-100 H-auto-tablet position-relative overflow-hidden disable-grid-space">
            <app-home-article-instagram [instagram]="instagram"></app-home-article-instagram>
        </div>
        <div class="w-100 H-100 H-100-full overflow-hidden grid-item-space disable-grid-space">
            <app-home-career [content]="home.career_section"></app-home-career>
        </div>
        <div  class="w-100 H-100 H-100-full H-auto-tablet  overflow-hidden remove-grid-borders-desktop">
            <app-footer></app-footer>
        </div>
        <div *ngIf="screenWidth > 767" class="d-none d-lg-block fade-overlay-menu" [ngClass]="{'active': activateMenuOverlay}"></div>
    </section>
</section>
